import { useEffect, useLayoutEffect } from "react";

/**
 * Use `useLayoutEffect` on the client, `useEffect` on the server. Avoids the
 * SSR warning React emits when `useLayoutEffect` runs during hydration.
 *
 * Adapted from the canonical pattern (popularized by usehooks-ts, MIT).
 */
export const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;
